"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Loading_module_scss_1 = __importDefault(require("./Loading.module.scss"));
function Loading(props) {
    var fullscreen = props.fullscreen, fullscreenTitle = props.fullscreenTitle, className = props.className, boxProps = __rest(props, ["fullscreen", "fullscreenTitle", "className"]);
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ className: (0, clsx_1.default)(Loading_module_scss_1.default.root, fullscreen && Loading_module_scss_1.default.fullscreen, className) }, boxProps, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: Loading_module_scss_1.default.spinner, role: 'progressbar', "aria-label": fullscreenTitle || 'Loading…' }, { children: [(0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", {})] })), fullscreen && fullscreenTitle ? (0, jsx_runtime_1.jsx)("div", __assign({ "aria-hidden": true }, { children: fullscreenTitle })) : null] })));
}
exports.Loading = Loading;
